/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMemberEvents32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M6 3.734c0-.13.104-.234.233-.234H7.35c.063 0 .122.025.165.068l.001.001a.232.232 0 01.069.165v1.755H6V3.734zM4.5 5.489V3.734C4.5 2.777 5.275 2 6.233 2H7.35a1.733 1.733 0 011.735 1.734v1.755H19.5V3.734c0-.957.775-1.734 1.733-1.734h1.117a1.732 1.732 0 011.735 1.734v1.755h4.876c.409 0 .799.162 1.087.449l.001.002c.288.288.45.678.45 1.086V30.99H1V7.026c0-.408.162-.798.45-1.086l.001-.002a1.54 1.54 0 011.087-.449H4.5zm17.25 0h-.749V3.734c0-.13.105-.234.233-.234h1.117c.063 0 .122.025.165.068l.002.002a.231.231 0 01.068.164v1.755h-.836zm0 1.5h.836V8.75h1.5V6.989h4.876A.04.04 0 0128.99 7c.007.008.01.017.01.026v3.963H2.5V7.026c0-.01.004-.018.01-.026a.04.04 0 01.028-.011h5.047V8.75h1.5V6.989H21.75zm-19.25 5.5H29v17H2.5v-17zm8 9.5v5.75H12v-5.75h7.5v5.75H21v-5.75h5.75v-1.5H21v-5.75h-1.5v5.75H12v-5.75h-1.5v5.75H4.75v1.5h5.75zm15.75-5.5a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z'
      />
    </svg>
  );
}

export default SvgMemberEvents32;
